const roles = {
  ADMIN: 'ROLE_ADMIN',
  PROVINCE: 'ROLE_PROVINCE',
  DISTRICT: 'ROLE_DISTRICT',
  WARD: 'ROLE_WARD'
};

export default {
  roles: roles,
  authenSuccesUrlRedirect: function (hasAuthor) {
    // if (hasAuthor(roles.CREATE)) {
    //   return '/user-management/managed-users';
    // } else if (hasAuthor(roles.CREATE)) {
    //   return '/user-management/managed-users';
    // } else {
    //   return '/user-management/managed-users';
    // }
    return '/dashboard.html'
  },

  authorizationMapper: [
    {
      regex: /^\/dashboard.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD);
      }
    },
    {
      regex: /^\/audio-station-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE);
      }
    },
    {
      regex: /^\/screen-station-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE);
      }
    },
    {
      regex: /^\/devices-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD);
      }
    },
    {
      regex: /^\/audio-editor\/send-to-station.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD);
      }
    },
    {
      regex: /^\/audio-editor*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD);
      }
    },
    {
      regex: /^\/screen-editor*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD);
      }
    },
    {
      regex: /^\/files-device-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD);
      }
    },
    {
      regex: /^\/files-screen-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD);
      }
    },
    {
      regex: /^\/report-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD);
      }
    },
    {
      regex: /^\/administrator\/location.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD);
      }
    },
    {
      regex: /^\/administrator\/contractor-information.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/file-type.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/user-activity-log.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE);
      }
    },
    {
      regex: /^\/residents-feedback-management\/managed-residents-feedback.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE);
      }
    },
    {
      regex: /^\/report-management\/send-TW.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE);
      }
    },
  ]
}
